import React from 'react';
import PropTypes from 'prop-types';
import SectionTitle from '../../_common/SectionTitle';
import { useConnect } from '@lore/query-connect';
import NetworkSite from './NetworkSite';

export default function Layout(props) {
  const { site } = props;

  const networks = useConnect('network.find', {
    where: {
      eager: {
        $where: {
          networkSites: {
            $where: {
              siteId: site.id
            }
          }
        }
      }
    }
  });

  return (
    <div className="page space-y-12">
      <div className="flex space-x-8">
        <div className="flex-1 space-y-12">
          <SectionTitle
            title="Networks"
            subtitle={(
              <>
                Networks this site is linked to.
              </>
            )}
          >
            <div className="grid grid-cols-1 gap-4">
              {networks.data.map(function(network) {
                return (
                  <NetworkSite
                    key={network.id}
                    network={network}
                    site={site}
                  />
                );
              })}
            </div>
          </SectionTitle>
        </div>
      </div>
    </div>
  );
};
